import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../data-access/authentication-service/authentication.service';

export const unauthorizedInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const authService = inject(AuthenticationService);

    return next(req).pipe(
        catchError((error) => {
            if (error.status === 401) {
                if (authService.isJwtExpired()) {
                    // Token has expired — triggers the session-expired snackbar.
                    authService.handleInvalid();
                }
            }
            return throwError(() => error);
        })
    );
};
